import { Link } from "react-router-dom";

export const LogoMark = ({ size = 38 }) => (
  <img
    src="/logo-mark.png"
    width={size}
    height={size}
    alt=""
    aria-hidden="true"
    data-testid="logo-mark"
    className="shrink-0"
  />
);

export const Logo = ({ compact = false }) => (
  <Link to="/" data-testid="brand-logo" className="flex items-center gap-3 shrink-0" aria-label="SourceWorld Automations — home">
    <LogoMark size={compact ? 34 : 42} />
    <span className="leading-none">
      <span className="block font-heading font-extrabold tracking-tight text-white text-base sm:text-lg">SourceWorld</span>
      <span className="block font-mono text-[10px] sm:text-[11px] tracking-[0.28em] uppercase text-sky-400 mt-1">Automations</span>
    </span>
  </Link>
);
